import { config } from "../config";
import OSREC from "./OSREC-lib";
// declare const OSREC: any;

const currencyOverride: any = { //override currency locale details in currencyformatterjs
    ie: {
        group: ','
    },
    pt: {
        group: '.'
    },
    es: {
        group: '.'
    },
    be: {
        group: '.'
    },
    ch: {
        group: "'" // eslint-disable-line quotes
    },
    gb: {
        group: ','
    },
    nl: {
        group: '.'
    },
    fr: {
        group: '.'
    },
    at: {
        group: '.'
    },
    de: {
        group: '.'
    },
    it: {
        group: '.'
    },
    jp: {
        group: ',',
        pattern: '!#,##0.'
    },
    se: {
        group: ' ',
        decimal: ',',
        pattern: '#,##0.00 !'
    },
    dk: {
        group: '.'
    },
    no: {
        group: ' ',
        decimal: ',',
        pattern: '#,##0.00 !'
    },
    cz: {
        group: ' '
    },
    nz: {
        group: ','
    },
    au: {
        group: ','
    },
    sk: {
        group: '.'
    },
    hu: {
        pattern: '#,##0. !',
        group: ' '
    },
    fi: {
        group: ' '
    },
    ca: {
        group: ','
    },
    us: {
        group: ','
    }
};

export const getCountryCurrencyOverride = function (country: string) {
    return currencyOverride[country?.toLowerCase()] || {};
};

export const currencyFormatter = (currencyNumber, fractionDigits?: any) => {
    const value = fractionDigits ? (currencyNumber / Math.pow(10, fractionDigits)).toFixed(fractionDigits) : currencyNumber;
    const defaultOptions = {
        locale: config('currencyLocale'),
        currency: config('currency'),
    };
    const currencyToBeOverriden: string = getCountryCurrencyOverride(config('regionCode'));
    const formattingOptions = Object.assign({}, defaultOptions, currencyToBeOverriden); // priority of options from low to high
    return OSREC.CurrencyFormatter.format(value, formattingOptions);
}

export const currencyFormatterOrders = (data, options) => {
    data = data || '';
    options = options || {};
    // Default options
    const defaultOptions = {
      locale: config('currencyLocale'),
      currency: config('currency'),
    };
    // Region specific options
    let currencyToBeOverriden = '';
    let country = (options.country || config('regionCode'));
    if (typeof country !== 'undefined') {
      currencyToBeOverriden = getCountryCurrencyOverride(country);
    }
    options = Object.assign({}, defaultOptions, currencyToBeOverriden, options); // priority of options from low to high
    return OSREC.CurrencyFormatter.format(data, options);
}

export const reverseFormatNumber = (value: string) => {
    const defaultOptions = {
        locale: config('currencyLocale'),
        currency: config('currency'),
    };

    const currencyToBeOverriden: string = getCountryCurrencyOverride(config('regionCode'));
    const formattingOptions = Object.assign({}, defaultOptions, currencyToBeOverriden, {});
    return OSREC.CurrencyFormatter.parse(value, formattingOptions);
};

export const getPriceValue = (price: string) => {
    let value: string;
    if (price.substring(0, 2) === 'kr') {
        value = price.substring(2).trim();
    }
    else if (price.substring(0, 3) === 'CHF') {
        value = price.substring(3).trim();
    }
    else if (price[price.length - 2] === 'K' || price[price.length - 2] === 'k' || price[price.length - 2] === 'F' || price[price.length - 2] === 'f') {
        value = price.substring(0, price.length - 2).trim();
    }
    else if (Number(price[0]) > -1) {
        value = price.substring(0, price.length - 1).trim();
    }
    else if (price[0] === '¥') {
        value = price.substring(1).trim();
    }
    else {
        value = price.substring(1).trim();
    }
    return value;
};

export const formatCurrencyForGa = (currencyNumber, fractionDigits) => {
    if (currencyNumber.toString().indexOf('.') == -1 && currencyNumber.toString().indexOf(',') == -1) {
        return currencyNumber.toString();
    }
    return (currencyNumber.toString().replace(/[^\d]/g, '') / Math.pow(10, fractionDigits)).toFixed(fractionDigits);
}
